// NATIVE 
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';


// CUSTOM 
import { Grid, IconButton, Tooltip } from '@mui/material';
import CheckboxField from '../../formFields/checkBoxField';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';


// INSTALLED 
import AutocompleteField from '../../formFields/autocompleteField';
import DatePickerEditField from '../../formFields/DatePickerEditField';




/**
 * SeguridadSocialEditar component is responsible for rendering the form fields related to social security information.
 * It utilizes Redux to fetch the necessary data and sets the default date based on the company's constitution date.
 * 
 * @param {any} props - The properties passed to the component.
 * @param {object} props.formField - The form fields for the component.
 * @param {object} props.formField.e_sgsst - The form field for SG-SST.
 * @param {object} props.formField.e_arl - The form field for ARL.
 * @param {object} props.formField.e_constitution_date - The form field for the constitution date.
 * @param {object} props.formField.e_ley_1429_2010 - The form field for Ley 1429 de 2010.
 * @param {object} props.formField.e_ley_590_2000 - The form field for Ley 590 de 2000.
 * @param {object} props.formField.e_ley_1607_2012 - The form field for Ley 1607 de 2012.
 * 
 * @returns {JSX.Element} The rendered component.
 */
export const SeguridadSocialEditar = (props:any) => {


    // REDUX 
    const { sgsst_list_select }:any = useSelector( (state:any) => state.sgsst );
    const { arl_list_select }:any   = useSelector( (state:any) => state.arl );
    const { company }:any  = useSelector( (state:any) => state.company );

    

    const [defaultDate, setDefaultDate] = useState<any>(new Date());


    

      const { formField: {
        e_sgsst,
        e_arl,
        e_constitution_date,
        e_ley_1429_2010,
        e_ley_590_2000,
        e_ley_1607_2012,
      }
    } = props;



    useEffect(() => {
      setDataDate(company);
    }, [company]);



    const setDataDate = (company:any) => {
      setDefaultDate(company.constitution_date)
    }





  return (
    <div>
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <AutocompleteField
                   options={sgsst_list_select}
                   name={e_sgsst.name}
                   label={e_sgsst.label}
                />
                
            </Grid>
            <Grid item xs={4}>
                <AutocompleteField
                   options={arl_list_select}
                   name={e_arl.name}
                   label={e_arl.label}
                />
            </Grid>
            <Grid item xs={4}>
              {/* dayjs */}
              

              <DatePickerEditField label={e_constitution_date.label} 
                                   name={e_constitution_date.name}
                                   defaultDate={defaultDate}/>

            </Grid> 
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={4} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={e_ley_1429_2010.name} label={e_ley_1429_2010.label}/>
                  <Tooltip title='La presente ley tiene por objeto la formalización y la generación de empleo, con el fin de generar incentivos a la formalización en las etapas iniciales de la creación de empresas; de tal manera que aumenten los beneficios y disminuyan los costos de formalizarse.'>
                    <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                  </Tooltip>
                  </div>
            </Grid>
            <Grid item xs={4}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={e_ley_590_2000.name} label={e_ley_590_2000.label}/>
                  <Tooltip title='Promover el desarrollo integral de las micro, pequeñas y medianas empresas en consideración a sus aptitudes para la generación de empleo, el desarrollo regional, la integración entre sectores económicos, el aprovechamiento productivo de pequeños capitales y teniendo en cuenta la capacidad empresarial de los colombianos.'>
                    <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                  </Tooltip>
                </div>
            </Grid>
            <Grid item xs={4}>
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={e_ley_1607_2012.name} label={e_ley_1607_2012.label}/>
                    <Tooltip title='Declaración Voluntaria del Impuesto sobre la Renta. El impuesto sobre la renta y complementarios, a cargo de los contribuyentes no obligados a declarar, es el que resulte de sumar las retenciones en la fuente por todo concepto que deban aplicarse a los pagos o abonos en cuenta, según el caso, realizados al contribuyente durante el respectivo año o período gravable.'>
                      <IconButton>
                        <HelpOutlineOutlinedIcon color='primary'/>
                      </IconButton>
                    </Tooltip>
                  </div>
            </Grid>
        </Grid>
       
        
    </div> 
  )
}
